import { render, staticRenderFns } from "./TermsPrivacy.vue?vue&type=template&id=3d113844&"
import script from "./TermsPrivacy.vue?vue&type=script&lang=js&"
export * from "./TermsPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports